import { Component } from "react";
import { connect } from "react-redux";
import UserDashboard from "./admin-dashboard";
import { showConfirmationModal } from "../redux-state/features/global-state/globalStateSlice";
import ConfirmationModal from "../shared-components/confirmationModal";
import OrderForm from "../shared-components/orderForm";
import ViewMaintenanceRequestModal from "./ViewMaintenanceRequestModal";
import ChangePassWordModal from "../shared-components/changePassWordModal";
class Admin extends Component {
  /**
   *
   */
  constructor() {
    super();
  }
  onCancel = () => {
    console.log("onCancel");
    this.props.showConfirmationModal(false);
  };
  deleteItem = () => {
    console.log("onConfirm");
  };
  render() {
    return (
      <div>
        <ChangePassWordModal />
        <ViewMaintenanceRequestModal />
        <OrderForm />
        <ConfirmationModal
          onCancel={this.onCancel}
          onConfirm={this.deleteItem}
        />
        <UserDashboard />
      </div>
    );
  }
}

const mapDispatchToProps = { showConfirmationModal };
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Admin);
